(function () {
  window.__lpReveal = true;
  var els = function () { return document.querySelectorAll('.lp-rv:not(.is-in)'); };
  function showAll() { els().forEach(function (e) { e.classList.add('is-in'); }); }
  function init() {
    var list = els();
    if (!list.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var design = window.Shopify && window.Shopify.designMode;
    if (!('IntersectionObserver' in window) || reduce || design) { showAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    list.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { showAll(); });
})();

/* floating stars around the "Buy it now" button while hovered / focused / pressed */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var timer = null, active = null, stopT = null;
  var kinds = ['g', 'w', 'p', 'g', 'w'];
  function spawn(btn) {
    var box = btn.querySelector('.lpc__now-stars');
    if (!box) { box = document.createElement('span'); box.className = 'lpc__now-stars'; box.setAttribute('aria-hidden', 'true'); btn.appendChild(box); }
    if (box.children.length > 9) return;
    var s = document.createElement('span');
    var r = Math.random(), x, y;
    if (r < 0.5) { x = 4 + Math.random() * 92; y = 0; }          // top edge
    else if (r < 0.7) { x = 4 + Math.random() * 92; y = 100; }   // bottom edge
    else if (r < 0.85) { x = 0; y = 15 + Math.random() * 70; }   // left edge
    else { x = 100; y = 15 + Math.random() * 70; }               // right edge
    var size = 9 + Math.random() * 9;
    s.className = 'lpc__fstar ' + kinds[Math.floor(Math.random() * kinds.length)];
    s.style.setProperty('--x', x + '%');
    s.style.setProperty('--y', y + '%');
    s.style.setProperty('--s', size.toFixed(1) + 'px');
    s.style.setProperty('--d', (1.9 + Math.random() * 1.2).toFixed(2) + 's');
    s.style.setProperty('--dx', ((Math.random() - 0.5) * 26).toFixed(1) + 'px');
    s.style.setProperty('--rise', (-(30 + Math.random() * 26)).toFixed(1) + 'px');
    s.addEventListener('animationend', function () { if (s.parentNode) s.parentNode.removeChild(s); });
    box.appendChild(s);
  }
  function loop() {
    if (!active) return;
    spawn(active);
    timer = setTimeout(loop, 380 + Math.random() * 420);
  }
  function start(btn) {
    if (btn.disabled) return;
    clearTimeout(stopT);
    if (active === btn) return;
    active = btn; clearTimeout(timer); loop();
  }
  function stop() { active = null; clearTimeout(timer); }
  document.addEventListener('mouseover', function (e) {
    var b = e.target.closest && e.target.closest('.lpc__now'); if (b) start(b);
  });
  document.addEventListener('mouseout', function (e) {
    var b = e.target.closest && e.target.closest('.lpc__now');
    if (b && !(e.relatedTarget && b.contains(e.relatedTarget))) stop();
  });
  document.addEventListener('focusin', function (e) { var b = e.target.closest && e.target.closest('.lpc__now'); if (b) start(b); });
  document.addEventListener('focusout', function (e) { if (e.target.closest && e.target.closest('.lpc__now')) stop(); });
  document.addEventListener('touchstart', function (e) {
    var b = e.target.closest && e.target.closest('.lpc__now');
    if (b) { start(b); clearTimeout(stopT); stopT = setTimeout(stop, 2600); }
  }, { passive: true });
})();

/* Link guard: LumiPals only ever links to itself, the cart, checkout and its own info pages.
   It never links to the LumiRoot storefront or to the LumiLiving home page. */
(function () {
  var main = function () { return document.querySelector('main[data-template="index"]'); };
  var HOME = '/products/lumipals';
  function allowed(p) {
    return p === HOME || p.indexOf(HOME + '/') === 0 ||
      /^\/(cart|checkout|checkouts|cdn|policies)(\/|$)/.test(p) ||
      /^\/pages\/(contact|data-sharing-opt-out)(\/|$)/.test(p);
  }
  function guard() {
    if (main()) return; /* the LumiLiving home page is allowed to link to both shops */
    document.querySelectorAll('a[href]').forEach(function (a) {
      var raw = a.getAttribute('href');
      if (!raw || raw.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(raw)) return;
      var u;
      try { u = new URL(raw, location.origin); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      var brand = a.getAttribute('data-brand');
      if (brand && brand !== 'lumipals') { a.removeAttribute('href'); a.setAttribute('aria-disabled', 'true'); a.style.pointerEvents = 'none'; a.style.cursor = 'default'; return; }
      if (allowed(u.pathname)) return;
      a.setAttribute('href', HOME);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard); else guard();
  if ('MutationObserver' in window) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(guard, 30); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
